var check = require('../util/regex-check');

module.exports = check(/[#-'*+\--9=?A-Z^-~]/);